export default {"src":"/_next/static/media/exel_is_creating.a13dfc56.svg","height":136,"width":183};